import React from 'react';
import styled from '@emotion/styled';
import { Controller } from 'react-hook-form';
import { FormPasswordInput } from 'ui/components/elements/FormInput/FormPasswordInput';
import { FormError } from 'ui/components/elements/FormError/FormError';
import { ActionButton } from 'ui/components/elements/ActionButton/ActionButton';
import { SnackBar } from 'ui/components/elements/SnackBar/SnackBar';
import { useSupporterPasswordRegistration } from './useSupporterPasswordRegistration';

const BgWrapper = styled.div`
    background-color: var(--supporter-green);
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

const Wrapper = styled.div`
    margin: 0 auto;
    padding: 40px 30px;
    border-radius: 12px;
    background-color: var(--white);
    width: 460px;
    height: 526px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    font-size: var(--font-medium);
    text-align: center;
`;

const Title = styled.div`
    font-size: var(--font-xxx-large);
    color: var(--supporter-green);
    font-weight: 600;
    margin-bottom: 20px;
    text-align: center;
`;

const Description = styled.div`
    font-size: var(--font-medium);
    font-weight: var(--font-bold);
    color: #626262;
    line-height: 1.5;

    ul {
        list-style-type: disc;
        text-align: left;
    }
`;

const ButtonContainer = styled.div`
    margin: 20px auto 0;
`;

export const SupportUserRegistrationPassword: React.FC = () => {
    const { control, loading, errors, showSnackbar, setShowSnackbar, send } = useSupporterPasswordRegistration();
    return (
        <BgWrapper>
            <Wrapper>
                <SnackBar message="パスワードを設定しました。" open={showSnackbar} setOpen={setShowSnackbar} />
                <Title>パスワード設定</Title>
                <Description>
                    <ul>
                        <li>8文字以上100文字以内で設定してください。</li>
                        <li>半角英字（a～z、A～Z）を1文字以上含めてください。</li>
                        <li>半角数字（0～9）を1文字以上含めてください。</li>
                    </ul>
                </Description>
                <Controller
                    name="password"
                    control={control}
                    render={({ field }) => (
                        <div>
                            <FormPasswordInput {...field} hasError={!!errors.password?.message} />
                            {errors.password?.message && <FormError message={errors.password.message} />}
                        </div>
                    )}
                />
                <ButtonContainer>
                    <ActionButton
                        disabled={loading}
                        onClick={send}
                        bgColor="main-color-blue"
                        style={{ maxWidth: '400px' }}
                    >
                        パスワードを設定する
                    </ActionButton>
                </ButtonContainer>
            </Wrapper>
        </BgWrapper>
    );
};
